import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getDispatchers,
  getBuildHealthInfo
} from '../reducers';
import {
  annotations as annotationActions,
  builds as buildActions,
  dispatchers as dispatcherActions,
  fetchJobBuildsByJobIds,
  jobs as jobActions,
  params as paramActions
} from '../actions';
import { buildHealth as buildHealthSelector } from '../selectors';
import { auth } from './../helpers';
import { keys } from 'lodash';
import BuildHealthComponent from './../Components/BuildHealthComponent.jsx';

export class BuildHealthContainer extends React.Component {
  static propTypes = {
    buildIds: PropTypes.array.isRequired,
    dispatcherIds: PropTypes.array.isRequired,
    dispatcherJobIds: PropTypes.array.isRequired,
    dispatchersByBuildIds: PropTypes.object,
    isAuthenticated: PropTypes.bool.isRequired,
    product: PropTypes.string,
    fetchBuildAnnotations: PropTypes.func.isRequired,
    fetchRCBuildsSinceLatestRelease: PropTypes.func.isRequired,
    fetchJobBuildsByJobIds: PropTypes.func.isRequired,
    fetchJobsByJobIds: PropTypes.func.isRequired,
    fetchDispatchersByBuildIds: PropTypes.func.isRequired,
    fetchParamsByJobIds: PropTypes.func.isRequired
  };

  componentDidMount() {
    this.props.fetchRCBuildsSinceLatestRelease(this.props.product);
    this.props.fetchBuildAnnotations();
    this.props.fetchDispatchersByBuildIds(this.props.buildIds);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.product !== this.props.product)
    {
      this.props.fetchRCBuildsSinceLatestRelease(this.props.product);
    }
    if (prevProps.buildIds.length !== this.props.buildIds.length)
    {
      this.props.fetchDispatchersByBuildIds(this.props.buildIds);
    }
    if (prevProps.dispatcherIds.length !== this.props.dispatcherIds.length)
    {
      this.props.fetchJobBuildsByJobIds(this.props.dispatcherJobIds);
      this.props.fetchJobsByJobIds(this.props.dispatcherJobIds);
      this.props.fetchParamsByJobIds(this.props.dispatcherJobIds);
    }
    this.props.fetchBuildAnnotations();
  }

  render() {
    return (
      <BuildHealthComponent isAuthenticated={this.props.isAuthenticated} />
    );
  }
}

export const mapStateToProps = (state) => {
  const buildHealthInfo = getBuildHealthInfo(state);
  const product = buildHealthInfo ? buildHealthInfo.product : '';
  const builds = buildHealthSelector.getBuildHealthPageBuilds(state);
  const buildIds = builds.map(b => b.id);
  const dispatchers = getDispatchers(state).filter(
    d => keys(d.scenarios_summary).length > 0);
  const dispatcherIds = dispatchers.map(d => d.id);
  const dispatcherJobIds = dispatchers.map(d => d.job_id);
  const props =
  {
    buildIds,
    dispatcherIds,
    dispatcherJobIds,
    isAuthenticated: auth.checkAuthenticated(),
    product
  };
  return props;
};

export default connect(
  mapStateToProps,
  {
    fetchBuildAnnotations: annotationActions.fetchBuildAnnotations,

    fetchRCBuildsSinceLatestRelease: buildActions.fetchRCBuildsSinceLatestRelease,
    fetchJobBuildsByJobIds,
    fetchJobsByJobIds: jobActions.fetchJobsByJobIds,
    fetchDispatchersByBuildIds: dispatcherActions.fetchDispatchersByBuildIds,
    fetchParamsByJobIds: paramActions.fetchParamsByJobIds
  }
)(BuildHealthContainer);


// WEBPACK FOOTER //
// src/Containers/BuildHealthContainer.jsx